<nav class="toolbar navbar navbar-light toolbar-no-button">
    <form class="form-inline" autocomplete="off">
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <h4>Informes Generales</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-6">

                                <p-listbox [options]="listInformesGenerales" formControlName="IdInformeGeneral" optionLabel="Descripcion"
                                           class="listBoxInformes listbox"
                                           [listStyle]="{'border':'0px;'}"
                                           (onChange)="onSelectTipoInformeGeneral()">
                                </p-listbox>
                            </div>
                        </div>

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('IdInformeGeneral','required')">
                            Tiene que seleccionar un informe a generar
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <h4>Informes Estadísticos</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-6">

                                <p-listbox [options]="listInformesEstadisticos" formControlName="IdInformeEstadistico" optionLabel="Descripcion"
                                           class="listBoxInformes listbox"
                                           [listStyle]="{'border':'0px;'}"
                                           (onChange)="onSelectTipoInformeEstadistico()">
                                </p-listbox>
                            </div>
                        </div>

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('IdInformeEstadistico','required')">
                            Tiene que seleccionar un informe a generar
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
